<template>
  <v-footer
    color="#F4FFBA"
    style="border-top: 2px solid #e0e0e0;"
    height="80px"
    fixed
  >
    <v-layout
      row
      text-xs-center
      justify-space-around
    >
      <template v-if="$store.getters.getCustomer && !$store.getters.getCustomer.onlyCatalogue">
        <v-flex xs2>
          <v-btn
            flat
            icon
            to="/campaigns"
            @click="countCampanha"
          >
            <v-icon medium>
              $vuetify.icons.houseIcon
            </v-icon>
          </v-btn>
        </v-flex>
        <v-flex xs2>
          <v-btn
            flat
            icon
            to="/contatos"
            @click="countAgenda"
          >
            <v-icon medium>
              $vuetify.icons.userCardIcon
            </v-icon>
          </v-btn>
        </v-flex>
        <v-flex
          v-if="$store.getters.isManager || $store.getters.isDirector"
          xs2
        >
          <v-btn
            flat
            icon
            to="/sellers"
            @click="countDashboard"
          >
            <v-icon>
              $vuetify.icons.unionIcon
            </v-icon>
          </v-btn>
        </v-flex>
        <v-flex
          xs2
        >
          <v-btn
            flat
            icon
            to="/pedidos"
            @click="countOrders"
          >
            <v-icon medium>
              $vuetify.icons.moneyCircleIcon
            </v-icon>
          </v-btn>
        </v-flex>
        <v-flex
          v-if="$store.getters.containsCatalogue"
          xs2
        >
          <v-btn
            flat
            icon
            to="/produtos"
            @click="countProdutos"
          >
            <v-icon medium>
              $vuetify.icons.openBookIcon
            </v-icon>
          </v-btn>
        </v-flex>

        <!-- <v-flex xs2>
          <v-card flat>
            <v-btn flat to="/resumo" @click="countResumo">
              <v-icon medium>bar_chart</v-icon>
            </v-btn>
          </v-card>
        </v-flex> -->

        <v-flex
          v-if="$store.getters.isManager || $store.getters.isDirector"
          xs2
        >
          <v-btn
            flat
            icon
            to="/dashboard/gestor"
            @click="countDashboard"
          >
            <v-icon>
              $vuetify.icons.targetIcon
            </v-icon>
          </v-btn>
        </v-flex>
      </template>
      <template v-else>
        <v-flex
          v-if="$store.getters.isManager || $store.getters.isDirector"
          xs4
        >
          <v-btn
            flat
            icon
            to="/sellers"
            @click="countDashboard"
          >
            <v-icon>
              $vuetify.icons.unionIcon
            </v-icon>
          </v-btn>
        </v-flex>

        <v-flex
          v-if="$store.getters.containsCatalogue"
          xs4
        >
          <v-btn
            flat
            icon
            to="/produtos"
            @click="countProdutos"
          >
            <v-icon medium>
              $vuetify.icons.openBookIcon
            </v-icon>
          </v-btn>
        </v-flex>

        <v-flex
          v-if="$store.getters.isManager || $store.getters.isDirector"
          xs4
        >
          <v-btn
            flat
            icon
            to="/dashboard/gestor"
            @click="countDashboard"
          >
            <v-icon>
              $vuetify.icons.targetIcon
            </v-icon>
          </v-btn>
        </v-flex>
      </template>
    </v-layout>
  </v-footer>
</template>

<script>

export default {
  data() {
    return {
      counterAgenda: 0,
      counterCampanha: 0,
      counterResumo: 0,
      counterProdutos: 0,
      counterDashboard: 0,
      counterSellers: 0,
      counterOrders: 0,
      validCustomers: ['5e8fb3bc454d620004792371', '5f3960ccdb0e3500032c99ad'],
    };
  },
  methods: {
    countAgenda() {
      this.counterAgenda += 1;
      this.$ga.event({
        eventCategory: 'Footer',
        eventAction: 'Menu Agenda',
        eventValue: this.counterAgenda,
      });
    },
    countCampanha() {
      this.counterCampanha += 1;
      this.$ga.event({
        eventCategory: 'Footer',
        eventAction: 'Menu Campanha',
        eventValue: this.counterCampanha,
      });
    },
    countResumo() {
      this.counterResumo += 1;
      this.$ga.event({
        eventCategory: 'Footer',
        eventAction: 'Menu Resumo',
        eventValue: this.counterResumo,
      });
    },
    countProdutos() {
      this.counterProdutos += 1;
      this.$ga.event({
        eventCategory: 'Footer',
        eventAction: 'Menu Produtos',
        eventValue: this.counterProdutos,
      });
    },
    countDashboard() {
      this.counterDashboard += 1;
      this.$ga.event({
        eventCategory: 'Footer',
        eventAction: 'Menu Dashboard Gestor',
        eventValue: this.counterDashboard,
      });
    },
    countSellers() {
      this.counterSellers += 1;
      this.$ga.event({
        eventCategory: 'Footer',
        eventAction: 'Menu Usuários',
        eventValue: this.counterSellers,
      });
    },
    countOrders() {
      this.counterOrders += 1;
      this.$ga.event({
        eventCategory: 'Footer',
        eventAction: 'Menu Pedidos',
        eventValue: this.counterOrders,
      });
    },
  },
};
</script>

<style scoped>
::v-deep .v-btn--active {
  border-bottom: 0px;
  color: #140C22 !important;
  opacity: 1 !important;
}
::v-deep .v-btn {
  opacity: 0.25;
}
.borda {
  border-style: solid;
  border-width: 2px 0px 0px 0px;
  border-color: #e0e0e0;
}
</style>
